module.exports = __webpack_public_path__ + "media/marry-your-daughter.db0edb54.mp3";